import type { TranslationKey } from '@/lib/i18n';

export const CART_SUMMARY_SUBTOTAL = [
  'sidecart:cart.subtotal',
  'Order Subtotal:',
] as const satisfies TranslationKey;

export const CART_SUMMARY_SAVINGS_LABEL = [
  'sidecart:cart.savingsLabel',
  "YOU'RE SAVING",
] as const satisfies TranslationKey;

export const CART_SUMMARY_CHECKOUT = [
  'sidecart:cart.checkout',
  'PROCEED TO CHECKOUT',
] as const satisfies TranslationKey;
